<template>
    <div class="dashboard-promo-banner dashboard-promo-banner--timer" :class="{ open: isOpen }">
      <div class="banner--content">
        <div class="banner-content-wrap">
          <div class="banner--content__left">
            <div class="promo">
              <div class="promo-intro">
                <span v-if="!deleteErrorMessage" v-translate>Account Marked for Deletion</span>
                <span v-if="deleteErrorMessage" v-translate>Error deleting account</span>
              </div>
                <span v-if="!deleteErrorMessage" @click="cancelDeleteProfile()" class="cancel-deletion-message">
                    {{ $gettext('This account is marked for deletion. Please click here in order to cancel the deletion process.') }}
                </span>
                <span v-if="deleteErrorMessage">{{ deleteErrorMessage }}</span>
            </div>
          </div>
          <div v-if="currentUser.profile && currentUser.profile.deletion_procedure" class="banner--content__right">
            <div class="flip-count">
              <span class="flip-title">{{ $gettext('The account will be deleted at:') }}</span>
              <FlipCount :time-until="currentUser.profile.deletion_procedure" />
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
  
  <script>
    import { mapGetters } from "vuex";
    import FlipCount from "@/components/dashboard/ui/FlipCount"
    import DashboardService from "@/store/services/dashboard.service"

    export default {
        name: "DeleteAccountBanner",
        components: {
        FlipCount
        },
        props: {
            deleteErrorMessage: {
                type: String,
                default: ''
            }
        },
        data () {
        return {
            isOpen: false,
            promoEnds: null,
            bannerType: null,
            debug: false
        }
        },
        computed: {
            bannerLink () {
                return '/subscriptions/manage/?selected=year'
            },
            ...mapGetters({
                currentUser: "main/getCurrentUser"
            })
        },
        created () {
            
        },
        mounted () {
            setTimeout(() => {
                this.isOpen = true
            }, 1000)
        },
        methods: {
          cancelDeleteProfile() {
            DashboardService.cancelDeleteProfile().then((response) => {
              if (response.status === 204) {
                if (this.$route.path.includes('delete')) window.location.href = window.Urls['gekkoDashboard']()
                else window.location.reload()
              }
            }).catch(() => {
              this.$store.commit('setAlert', { title: this.$gettext('Error'), text: this.$gettext('An error occurred while cancelling your account deletion. Please contact support@getgekko.com for assistance.'), variant: 'danger', duration: 4 })
            })
          }
        }
    }
  </script>
  <style lang="scss" scoped>
    .dashboard-promo-banner--timer {
      background: linear-gradient(103deg, #b30e0e, #680d0d) !important;
    }
  </style>